export const getOrgId = (orgReducer) => orgReducer?.orguid;

export const orguid = (orgReducer) => orgReducer?.selectedFI?.orguid;

export const API_STATUS = {
  STATUS_IDLE :"STATUS_IDLE",
  STATUS_LOADING : "STATUS_LOADING",
  STATUS_SUCCESS : "STATUS_SUCCESS",
  STATUS_FAILURE : "STATUS_FAILURE",
}